/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentGradebookSubmissionGradeParser = 
/* #__PURE__ */ parsers.object([
    ['submissionId', codecNumber, 'submission_id'],
    ['grade', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class AssignmentGradebookSubmissionGrade extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentGradebookSubmissionGradeParser.decode(input).map(res => new AssignmentGradebookSubmissionGrade(res));
    }
    static unsafeDecode(input) {
        return AssignmentGradebookSubmissionGrade.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentGradebookSubmissionGradeParser.encode(data);
    }
    static schema() {
        return AssignmentGradebookSubmissionGradeParser.schema();
    }
}
